import React from 'react';
import type { OptionProps, GroupBase } from 'react-select';
import { components } from 'react-select';

import { SearchableSelectType } from '../../../components/inputs/searchableSelect';
// components
import LabelChip from '../../../components/labels/LabelChip';
import styled from 'styled-components';

const MORE_ICON_DIV = 'more-icon-div';

const AlternateLabelDropdownOption: React.FC<
    React.PropsWithChildren<
        OptionProps<
            SearchableSelectType,
            boolean,
            GroupBase<SearchableSelectType>
        >
    >
> = (props) => {
    return (
        <components.Option {...props}>
            <OptionContent>
                <LabelChip
                    title={props.label}
                    isHighlighted={props.data.isHighlighted}
                />
            </OptionContent>
        </components.Option>
    );
};

const OptionContent = styled.div(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    ':hover': {
        [`& .${MORE_ICON_DIV}`]: {
            visibility: 'visible',
        },
    },
}));

export default AlternateLabelDropdownOption;
